export const environment = {
  production: true,
  REACT_APP_COGNITO_USER_POOL_REGION: "eu-west-1",
  REACT_APP_COGNITO_USER_POOL_ID: "eu-west-1_pqLJoghtW",
  REACT_APP_COGNITO_APP_CLIENT_ID: "180t69t6llng78r07vpt77h3im",
  apiUrl: "https://api.mag8000.siemens.com",
};
